import React, {
  InputHTMLAttributes,
  useEffect,
  useRef,
  useState,
  useCallback,
} from 'react';
import { FiAlertCircle } from 'react-icons/fi';
import { useField } from '@unform/core';

import { Container, Error } from './styles';

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  name: string;
  styled?: boolean;
  show?: boolean;
  suggestions?: string;
}

const Input: React.FC<InputProps> = ({
  name,
  show,
  styled,
  suggestions,
  ...rest
}) => {
  const inputRef = useRef<HTMLInputElement>(null);
  const [isFocused, setIsFocused] = useState(false);
  const [isFilled, setIsFilled] = useState(false);
  const { fieldName, defaultValue, error, registerField } = useField(name);

  const handleInputFocus = useCallback(() => {
    setIsFocused(true);
  }, []);

  const handleInputBlur = useCallback(() => {
    setIsFocused(false);
    setIsFilled(!!inputRef.current?.value);
  }, []);

  useEffect(() => {
    if (suggestions)
      if (inputRef.current) inputRef.current.value = suggestions ?? '';
  }, [suggestions]);

  useEffect(() => {
    registerField({
      name: fieldName,
      ref: inputRef.current,
      path: 'value',
    });
  }, [fieldName, registerField]);

  return (
    <>
      {styled === false ? (
        <>
          <input
            onFocus={handleInputFocus}
            onBlur={handleInputBlur}
            defaultValue={defaultValue}
            ref={inputRef}
            {...rest}
          />
          {error && (
            <Error content="">
              <FiAlertCircle color="#c53030" size={20} />
            </Error>
          )}
        </>
      ) : (
        <Container
          $show={show?.toString()}
          $isErrored={!!error}
          $isFilled={isFilled}
          $isFocused={isFocused}
        >
          <input
            onFocus={handleInputFocus}
            onBlur={handleInputBlur}
            defaultValue={defaultValue}
            ref={inputRef}
            {...rest}
          />
          {error && (
            <Error content="" title={error}>
              <FiAlertCircle color="#c53030" size={20} />
            </Error>
          )}
        </Container>
      )}
    </>
  );
};

export default Input;
